import {
    GET_LIST_BRANCH_FUNDS,
} from '@/redux/actions/types';

/**
 * initial state
 */
const INIT_STATE = {
    branch_funds_list: [],
    pagination: {
        currentPage: 1,
        total: 0, // total records
        perPage: 30
    },
    summary: {
        TongQuyNhap: 0,
        ChiTrongNgay: 0,
        TonQuyChi: 0,
    }
};

// Dùng parseFloat để hỗ trợ số có phần thập phân
const toFloat = (v, fallback = 0) => {
    const n = Number.parseFloat(v);
    return Number.isNaN(n) ? fallback : n;
};

// Dùng parseInt nếu cần ép kiểu nguyên (có thể giữ lại nếu muốn)
const toInt = (v, fallback = 0) => {
    const n = Number.parseInt(v, 10);
    return Number.isNaN(n) ? fallback : n;
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LIST_BRANCH_FUNDS: {
            const payload = action.payload && typeof action.payload === 'object' ? action.payload : {};
            const listData = payload.list || {};
            const summaryData = payload.summary || {};

            return {
                ...state,
                branch_funds_list: listData.data || [],
                pagination: {
                    currentPage: toInt(listData.current_page, state.pagination.currentPage),
                    total: toInt(listData.total, state.pagination.total),
                    perPage: toInt(listData.per_page, state.pagination.perPage),
                },
                summary: {
                    TongQuyNhap: toFloat(summaryData.TongQuyNhap, 0),
                    ChiTrongNgay: toFloat(summaryData.ChiTrongNgay, 0),
                    TonQuyChi: toFloat(summaryData.TonQuyChi, 0),
                }
            };
        }

        default:
            return state;
    }
};
